const MENU_TYPES = {
    DETAIL: "detail",
    VISIBILITY: "visibility",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.DETAIL,
        label: that?.$t("Linkedin Channel Detail") || "Linkedin Channel Detail",
        icon: {
            type: "material-icons",
            name: "info",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.VISIBILITY,
        label: that?.$t("multi_whatsapp_api.visibility") || "Visibility",
        icon: {
            type: "material-icons",
            name: "visibility",
        },
    },
];

export default {
    MENU_TYPES,
    Items,
};
